
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 86.384 48.4"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 88","d":"M.764 7.167v33.445a7.166 7.166 0 007.167 7.167h66.5a7.166 7.166 0 007.167-7.167V7.167A7.166 7.166 0 0074.431 0h-66.5A7.166 7.166 0 00.764 7.167","fill":"#4e4d4d"}}),_c('path',{attrs:{"data-name":"Path 89","d":"M2.484 7.614V40.16a5.619 5.619 0 005.619 5.619h66.159a5.619 5.619 0 005.618-5.619V7.614a5.619 5.619 0 00-5.618-5.619H8.103a5.619 5.619 0 00-5.619 5.619","fill":"#fff"}}),_c('path',{attrs:{"data-name":"Path 90","d":"M2.329 7.614V40.16a5.619 5.619 0 005.619 5.619H41.18V1.995H7.948a5.619 5.619 0 00-5.619 5.619","fill":"#4d4d4d"}}),_c('path',{attrs:{"data-name":"Path 91","d":"M2.329 7.614V40.16a5.619 5.619 0 005.619 5.619H41.18V1.995H7.948a5.619 5.619 0 00-5.619 5.619z","fill":"none","stroke":"#4d4d4d"}}),_c('path',{attrs:{"data-name":"Path 92","d":"M86.383 15.487v17.9c0 .956-1.046 1.732-2.336 1.732h-3.894V13.755h3.894c1.29 0 2.336.776 2.336 1.732","fill":"#4e4d4d"}})])
          )
        }
      }
    